import {
  LabelContainer,
  MapContainer,
  Rating,
  RatingLabel,
  RatingsContainer,
  StarsContainer,
  ZoneContainer,
} from './zone.styles';
import { ReactComponent as Star } from '../../../assets/images/star.svg';
import { ReactComponent as StarFill } from '../../../assets/images/starFill.svg';
import { ReactComponent as Education } from '../../../assets/images/education.svg';
import { ReactComponent as Entertainment } from '../../../assets/images/entertainment.svg';
import { ReactComponent as Health } from '../../../assets/images/health.svg';
import { ReactComponent as Hostelery } from '../../../assets/images/hosteleria.svg';
import { ReactComponent as Market } from '../../../assets/images/market.svg';
import { ReactComponent as GreenAreas } from '../../../assets/images/plotLand.svg';
import { ReactComponent as Sports } from '../../../assets/images/sports.svg';
import { ReactComponent as Transport } from '../../../assets/images/transport.svg';
import { HalfPageModule, SectionTitle } from '../../../styles/global.styles';
import { ZoneDataModel } from '../../../types/indicators.interfaces';
import { CSSProperties, useState } from 'react';
import NoMapPlaceholder from '../../../assets/images/img-no-map.svg';
import { useIntl } from 'react-intl';

export function Zone(props: ZoneDataModel) {
  const intl = useIntl();
  const labelDictionary = {
    education: {
      label: intl.formatMessage({
        id: 'glossary.know_the_area.KnowTheZone.education',
      }),
      icon: <Education />,
    },
    health: {
      label: intl.formatMessage({
        id: 'glossary.know_the_area.KnowTheZone.health',
      }),
      icon: <Health />,
    },
    supermarkets: {
      label: intl.formatMessage({
        id: 'glossary.know_the_area.KnowTheZone.supermarkets',
      }),
      icon: <Market />,
    },
    catering: {
      label: intl.formatMessage({
        id: 'glossary.know_the_area.KnowTheZone.catering',
      }),
      icon: <Hostelery />,
    },
    public_transport: {
      label: intl.formatMessage({
        id: 'glossary.know_the_area.KnowTheZone.public_transport',
      }),
      icon: <Transport />,
    },
    offer_leisure__culture: {
      label: intl.formatMessage({
        id: 'glossary.know_the_area.KnowTheZone.leisure_and_culture',
      }),
      icon: <Entertainment />,
    },
    green_areas: {
      label: intl.formatMessage({
        id: 'glossary.know_the_area.KnowTheZone.green_area',
      }),
      icon: <GreenAreas />,
    },
    sports: {
      label: intl.formatMessage({
        id: 'glossary.know_the_area.KnowTheZone.sports',
      }),
      icon: <Sports />,
    },
  };
  const center = {
    lat: props.coordinates[0],
    lng: props.coordinates[1],
  };
  const mapContainerStyle = {
    borderRadius: '8px',
  };
  return (
    <HalfPageModule>
      <SectionTitle>
        {intl.formatMessage({
          id: 'glossary.know_the_area.knowTheZone.title',
        })}
      </SectionTitle>
      <ZoneContainer>
        <RatingsContainer>
          {props.ratings.map((item) => (
            <Rating key={item.id}>
              <LabelContainer>
                {labelDictionary[item.id as keyof typeof labelDictionary].icon}
                <RatingLabel>
                  {
                    labelDictionary[item.id as keyof typeof labelDictionary]
                      .label
                  }
                </RatingLabel>
              </LabelContainer>
              {item.value ? (
                <StarsContainer>
                  {[...Array(5)].map((_, index) =>
                    index < (item.value ?? 0) ? (
                      <StarFill key={index} />
                    ) : (
                      <Star key={index} />
                    )
                  )}
                </StarsContainer>
              ) : (
                <StarsContainer>-</StarsContainer>
              )}
            </Rating>
          ))}
        </RatingsContainer>
        <MapContainer>
          <ImageWithFallback
            src={`https://maps.googleapis.com/maps/api/staticmap?center=${center.lat},${center.lng}&zoom=15&size=800x250&scale=1&maptype=roadmap&markers=color:red%7C${center.lat},${center.lng}&key=${process.env.REACT_APP_STREET_VIEW_API_KEY}`}
            alt="Map"
            style={mapContainerStyle}
            fallbackSrc={NoMapPlaceholder}
          />
        </MapContainer>
      </ZoneContainer>
    </HalfPageModule>
  );
}

const ImageWithFallback = ({
  src,
  fallbackSrc,
  alt,
  style,
}: {
  src: string;
  fallbackSrc: string;
  alt: string;
  style: CSSProperties;
}) => {
  const [currentSrc, setCurrentSrc] = useState(src);
  const [hasError, setHasError] = useState(false);

  const handleImageError = () => {
    if (!hasError && fallbackSrc) {
      setCurrentSrc(fallbackSrc);
      setHasError(true);
    }
  };

  return (
    <img src={currentSrc} alt={alt} onError={handleImageError} style={style} />
  );
};
